import type { Configuration } from "@azure/msal-browser";

// AAD app registration created via az CLI on 2026-04-27.
// These values are public (the SPA flow uses PKCE, no client secret).
export const AAD_CLIENT_ID = "bb35c34b-42e0-4fae-ad96-55c9e6969120";

// Accepts AAD work/school accounts from any tenant AND personal Microsoft
// accounts (outlook.com, hotmail.com, live.com). Pair with the AAD app's
// signInAudience = AzureADandPersonalMicrosoftAccount.
export const AAD_AUTHORITY = "https://login.microsoftonline.com/common";

export const SCOPES = ["User.Read", "openid", "profile", "email"];

/**
 * Build an MSAL configuration. The redirect URI is the CURRENT PAGE'S URL —
 * so MSAL.handleRedirectPromise() on the same page picks up the auth response
 * after AAD bounces the user back. The two pages that call this:
 *
 *   - taskpane.html → loginRedirect from the parent task pane (browser path)
 *   - dialog.html   → loginRedirect inside the Office dialog window
 *
 * Both URIs are registered as SPA redirects in the AAD app so AAD accepts
 * either one depending on which page invoked the auth.
 */
export function buildMsalConfig(): Configuration {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://localhost:3000";
  // window.location.pathname includes the leading slash (e.g. "/dialog.html").
  // Strip query/hash so we always redirect back to the bare page URL.
  const path =
    typeof window !== "undefined" && window.location.pathname
      ? window.location.pathname
      : "/taskpane.html";
  const redirectUri = `${origin}${path}`;
  // NAA (Nested App Authentication) is enabled by constructing the MSAL
  // instance via `createNestablePublicClientApplication(config)`. That factory
  // returns a NAA-aware client when the page is inside an Office host that
  // supports the AuthBridge, or a standard client otherwise. No flag is
  // required on the config itself — see AuthProvider.tsx.
  return {
    auth: {
      clientId: AAD_CLIENT_ID,
      authority: AAD_AUTHORITY,
      redirectUri,
      postLogoutRedirectUri: `${origin}/taskpane.html`,
    },
    cache: {
      cacheLocation: "localStorage",
    },
  };
}
